export function formatNumber(amount, rounding, noCommas) {
    if (amount === null || amount === undefined) return amount

    let value = (amount + '').replace(/,/g, '') - 0
    if (isNaN(value)) return amount

    let useRounding = !isNaN(rounding) && rounding > 0, precision = 10
    if (useRounding) {
        value = rounding * Math.round(value / rounding)
        precision = ((rounding + '').split('.')[1] || '').length
    }

    let [whole, fraction] = (value + '').split('.')

    whole = whole.split('')

    //  Remove any leading non-numeric sign characters and add them back at the end
    let sign = isNaN(whole[0]) ? whole.shift() : ''

    if (!noCommas)
        for (let pos = whole.length - 3; pos > 0; pos -= 3)
            whole.splice(pos, 0, ',')

    whole = whole.join('')

    if (useRounding && rounding < 1 && fraction === undefined)
        fraction = ''

    if (fraction !== undefined && precision > 0) {
        if (useRounding) {
            let diff = fraction.length - precision
            if (diff < 0)
                fraction += Array(1 - diff).join('0')
            else if (diff > 0) {
                fraction = fraction.split('')
                fraction.splice(precision, 0, '.')
                fraction = fraction.join('')

                fraction = Math.round(fraction - 0) + ''

                diff = fraction.length - precision

                if (diff < 0) fraction = Array(1 - diff).join('0') + fraction
                else fraction = Array(1 + diff).join('0') + fraction
            }
        }

        whole += '.' + fraction
    }

    return sign + whole
    //return (sign == '-') ? `(${whole})` : whole
}

export function format(amount, currency, raw) {
    if (!currency) return formatNumber(amount)

    if (typeof currency === "string")
        currency = { code: currency }

    let formattedNumber = formatNumber(amount, currency.rounding)
    if (formattedNumber === null)
        return null

    if (currency.symbol) {
        if (formattedNumber[0] == '-') return `-${currency.symbol}${formattedNumber.slice(1)}`
        return `${currency.symbol}${formattedNumber}`
    }
    if (currency.code && !raw) return `${formattedNumber} ${currency.code}`

    return formattedNumber
}

let dateFunctions = ["FullYear", "Month", "Date", "Hours", "Minutes", "Seconds", "Milliseconds"]
    .map(p => ({
        local: Date.prototype[`get${p}`],
        utc: Date.prototype[`getUTC${p}`],
    }))

let localDateFns = dateFunctions.map(o => o.local)
let utcDateFns = dateFunctions.map(o => o.utc)

//  This will be set once at page load for performance,
//      so if the user changes their timezone they'd have to refresh the page before it changes anything
export let timezoneOffset = new Date().getTimezoneOffset()

export function dateParts(date, getUTC) {
    // Use instanceof because Vue may create a Date wrapper function making a direct equality check fail
    if (!date || !(date instanceof Date)) return

    let [Y, M, D, h, m, s, ms] = (getUTC ? utcDateFns : localDateFns).map(fn => fn.apply(date))
    let [MM, DD, hh, mm, ss] = [M + 1, D, h, m, s].map(n => (n < 10) ? `0${n}` : n)

    return { YYYY: `${Y}`, MM, DD, hh, mm, ss, ms: `00${ms}`.slice(-3) }
}

export function isoDate(date, getUTC) {
    let parts = dateParts(date, getUTC)
    if (parts) {
        let { YYYY, MM, DD } = parts
        return `${YYYY}-${MM}-${DD}`
    }
}

export function isoString(date, getUTC) {
    let parts = dateParts(date, getUTC)
    if (parts) {
        let { YYYY, MM, DD, hh, mm, ss, ms } = parts
        return `${YYYY}-${MM}-${DD}T${hh}:${mm}:${ss}.${ms}`
    }
}

export function ddMMMyyyy(date) {
    if (date) {
        try {
            const options = {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            }
            return new Date(date).toLocaleDateString('en-GB', options)
        }
        catch (e) { }
    }
}